import {getTestProps} from '@benchling/js-test-utils';
import {css} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {makeNavbarBackgroundStyles} from 'nav/navbar/NavBarColor';

import * as SidepanelActions from '../sidepanel/SidepanelActions';
import HomeIcon from './HomeIcon';
import {navBarContentsStyles} from './NavBarContents';

export default function SignedOutNavBarContents(): JSX.Element {
  return (
    <div
      className={classNames(css(navBarContentsStyles.navbar), 'js-navTour-nav')}
      style={makeNavbarBackgroundStyles()}
      role="tablist"
      {...getTestProps({component: 'SignedOutNavBarContents', element: 'root'})}
    >
      <HomeIcon
        icon="benchling"
        isActive={true}
        onHomeIconClick={(section) => {
          SidepanelActions.unexpandToSection(section);
        }}
      />
    </div>
  );
}
